import React from 'react';
import { motion } from 'framer-motion';
import logo from '../assets/logo.png'; // make sure this is correctly imported
import backgroundImage from '../assets/servicesbackground.png'; // your background image
import mobileBackgroundImage from '../assets/servicesbackground-mobile.png';

const Services = () => {
  const services = [
    { title: "Live Classes – Math & Science", desc: "Learn from expert tutors with our engaging live Math and Science classes." },
    { title: "AI Test Series", desc: "Practice personalized questions & receive AI-generated reports for improvement." },
    { title: "Notes & Slides", desc: "Comprehensive notes and smart slides for quick revision." },
    { title: "Live Doubt Clearing", desc: "Real-time 1:1 doubt support for students." },
    { title: "Personality Development", desc: "Speak with impact — public speaking, debates, and confidence training for every learner." },
    { title: "Tech & Digital Solutions", desc: "Upskill with digital training and get powerful tech solutions tailored to your business." },
  ];

  return (
    <div className="relative min-h-screen">

     {/* Background Image */}
<div
  className="absolute inset-0 bg-cover bg-center bg-no-repeat"
  style={{
    backgroundImage: `url(${backgroundImage})`,
  }}
>
  {/* Mobile Background Overlay */}
  <div
    className="absolute inset-0 sm:hidden bg-cover bg-center bg-no-repeat"
    style={{
      backgroundImage: `url(${mobileBackgroundImage})`,
      backgroundColor: '#fff', // Optional: ensures clean overlay
    }}
  />
</div>



      {/* Pink Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-pink-200/50 to-pink-100/70" />

      {/* Navigation Bar */}
      <div className="w-full fixed top-0 left-0 bg-gradient-to-r from-pink-100 to-pink-50 shadow z-50 px-8 py-4 flex justify-between items-center">
        <img src={logo} alt="Mini Logo" className="h-10 w-auto" />
        <nav className="flex space-x-6 text-gray-800 font-medium">
          <a href="/" className="hover:text-pink-600 transition">Home</a>
          <a href="/#about" className="hover:text-pink-600 transition">About</a>
          <a href="/services" className="hover:text-pink-600 transition">Services</a>
          <a href="https://forms.gle/dAbSkxLQuQhuhVur5" target="_blank" rel="noopener noreferrer" className="hover:text-pink-600 transition">Contact</a>
        
        </nav>
      </div>

      {/* Services Content */}
      <div className="relative px-6 pt-32 pb-16"> {/* add pt-32 to avoid overlap with fixed navbar */}
        <h1 className="text-4xl font-bold text-center text-gray-800 mb-12">Our Services</h1>
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="bg-pink-50 rounded-2xl shadow-md p-6 hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <h3 className="text-xl font-semibold text-pink-800 mb-2">{service.title}</h3>
              <p className="text-gray-600">{service.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
